import { useMemo } from 'react';
import { useRetriveDsoCart } from './useRetriveDsoCart';
import { dsoCheckoutService } from 'services';
import { useRetrieveDsoShippingAddresses } from 'reactQuery/queries/dso/useRetrieveDsoShippingAddresses';

export const useRetriveDsoCartSummary = () => {
  const { data: cart, isLoading: isCartLoading } = useRetriveDsoCart();
  const { data: shippingAddresses, isLoading: isShippingAddressesLoading } =
    useRetrieveDsoShippingAddresses();

  const cartSummary = useMemo(() => {
    if (!cart) return undefined;
    return dsoCheckoutService.getCartSummary(cart, shippingAddresses);
  }, [cart, shippingAddresses]);

  const cartSummaryByProduct = useMemo(() => {
    if (!cart) return undefined;
    return dsoCheckoutService.getCartSummaryByProducts(cart, shippingAddresses);
  }, [cart, shippingAddresses]);

  return {
    data: cartSummary,
    dataByProduct: cartSummaryByProduct,
    isLoading: isCartLoading || isShippingAddressesLoading,
  };
};
